import List from '@mui/material/List';
import Stack from '@mui/material/Stack';
import SimpleBar from 'simplebar-react';
import { NavigationHeader } from './NavigationHeader/NavigationHeader';
import { NavigationBlockEmpty } from './NavigationBlockEmpty/NavigationBlockEmpty';
import { INavigationBlockProps, INavigationBlockItemBase } from './NavigationBlock.interface';

export const NavigationBlock = <T extends INavigationBlockItemBase>(props: INavigationBlockProps<T>) => {
  const { header, headerAction, items, isLoading, NavigationItemComponent } = props;

  const isEmpty = items.length === 0;
  const isNoRecords = isLoading || isEmpty;

  return (
    <Stack sx={{
      height: '100%',
    }}>
      <NavigationHeader
        component={'div'}
        title={header}
        action={headerAction}
      />
      <List sx={{ overflow: 'hidden', flex: 1, padding: 0 }}>
        <SimpleBar style={{
          height: '100%',
          width: '100%',
          overflow: 'auto',
        }}>
          {isNoRecords && (
            <NavigationBlockEmpty isLoading={isLoading} isEmpty={isEmpty} />
          )}
          {!isNoRecords &&
           items.map((item) => (
             <NavigationItemComponent key={item.value} item={item} />
           ))}
        </SimpleBar>
      </List>
    </Stack>
  );
};
